import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

export enum SupportedEntitySelectorType {
  All,
  Single,
  FieldValueEquals,
  FieldValueEqualsUserFieldValue,
  FieldValueEqualsUserEntityId,
}

type EntitySelectorTypeProps = {
  optionsWithLabels: Map<SupportedEntitySelectorType, string>
  selected: SupportedEntitySelectorType
  setSelected: (type: SupportedEntitySelectorType) => void
  disabled?: boolean
  size?: 'small' | 'medium'
}

const EntitySelectorTypeInput = ({
  optionsWithLabels,
  selected,
  setSelected,
  disabled,
  size = 'small',
}: EntitySelectorTypeProps) => (
  <FormControl sx={{ minWidth: 160 }} size={size}>
    <InputLabel id="entity-selector-type-input">Filter</InputLabel>
    <Select
      labelId="entity-selector-type-label"
      value={selected}
      label="Filter"
      onChange={(event) => setSelected(event.target.value as SupportedEntitySelectorType)}
      disabled={disabled}
      size={size}
    >
      {Array.from(optionsWithLabels.entries()).map(([type, label]) => (
        <MenuItem key={label} value={type}>
          {label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default EntitySelectorTypeInput
